import { Button, Divider, Modal } from "antd-mobile";
import { CloseOutline } from 'antd-mobile-icons'
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

export const isAlphaNum = (inputString) => {
  // Regular expression to match alphanumeric characters
  var alphanumericRegex = /^[a-zA-Z0-9-]+$/;
  // Test if the input string matches the alphanumeric pattern
  return alphanumericRegex.test(inputString);
}

export const monthsOld = (_timestamp) => {
  // Calculate the age of the timestamp in months
  const timestampMilliseconds = _timestamp * 1000;
  const currentDate = new Date();
  const timestampDate = new Date(timestampMilliseconds);
  const monthsDiff = (currentDate.getFullYear() - timestampDate.getFullYear()) * 12 + (currentDate.getMonth() - timestampDate.getMonth());
  return monthsDiff;
}

export const drawPrice = (_num, _from_int = false) => {
  if (isNaN(parseInt(_num))) {
    return "";
  } else {
    if (_from_int) {
      _num = _num / 100;
    }
    return Number(_num).toFixed(2);
  }
}


export const bm_date = (input, format = "MMMDD-YY") => {

  if (!input) return '';
  if (input) { input = input.toString().trim() }

  input = String(input).trim();
  dayjs.extend(utc);
  dayjs.extend(customParseFormat);



  let parsedDate;

  // Check for YYYY
  if (/^\d{4}$/.test(input)) {
    parsedDate = dayjs(input, 'YYYY');
  }
  // Check for YYYYMM
  else if (/^\d{6}$/.test(input) && parseInt(input.substring(0, 2), 10) >= 13) {
    parsedDate = dayjs(input, 'YYYYMM');
  }
  // Check for YYYYMMDD
  else if (/^\d{8}$/.test(input)) {
    parsedDate = dayjs(input, 'YYYYMMDD');
  }
  // Check for YYYY-MM-DD
  else if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
    parsedDate = dayjs(input, 'YYYY-MM-DD');
  }
  // Check for MMDDYY
  else if (/^\d{6}$/.test(input) && parseInt(input.substring(0, 2), 10) <= 12) {
    parsedDate = dayjs(input, 'MMDDYY');
  }
  // Check if it's a timestamp (milliseconds or seconds)
  else if (/^\d+$/.test(input)) {
    parsedDate = input.length <= 10 ? dayjs.unix(input) : dayjs(parseInt(input, 10));
  }
  // Invalid
  else { return ''; }

  return parsedDate.isValid() ? parsedDate.utc().format(format) : '';
};

export const drawError = (_message, _button = "Close", _callback = () => { }, _title = "Error", _can_close = true) => {

  const handler = Modal.show({
    title: <div>{_title} {(_can_close && <div style={{ "position": "absolute", "right": "15px", "top": "10px", "cursor": "pointer" }} onClick={() => handler.close()}><CloseOutline /></div>)} <br /></div>,
    content: (
      <div style={{ "textAlign": "center", "maxWidth": "260px" }}>{_message}<br /><br />
        {(_button && <Button danger block onClick={() => { handler.close(); _callback(); }}>{_button}</Button>)}
      </div>
    ),
    closeOnMaskClick: (_button),
  });
}